<section id="loginRegisterButton" class="btnBlock topLoginSection">
  <button class="btn-primary headerLoginBtn" [ngStyle]="{'margin-right.px': '10'}" [ngbPopover]=popTitleSuccessLogout
    placement="bottom" triggers="manual" #p5="ngbPopover" popoverClass="sign_out" container="body" placement="bottom"
  [closeDelay]="1000" (click)="showLogin()">Log In</button>

  <!-- Feature Flag -->
  <!-- Old Onboarding Flow Button -->
  @if (!isNewOnboardingMigrated) {
    <div>
      <button class="btn-secondary rebr-btn-secondary" (click)="goToRegister()">Register</button>
    </div>
  }
  <!-- New Onboarding Flow Button -->
  @if (isNewOnboardingMigrated) {
    <div>
      <button class="btn-secondary rebr-btn-secondary" (click)="goToNewOnboarding()">Register</button>
    </div>
  }
  <!-- End Feature Flag -->

  <ng-template #popTitleSuccessLogout>
    <div class="logOutMsg">
      <span class="successLogOutMsg">
        You have signed out of your account
      </span>
    </div>
  </ng-template>
</section>
<section (mouseleave)="closepop()" class="cart-icons" id="miniCart">
  @if (isEmpty) {
    <a class="clear-cart" [ngbPopover]="popContentEmpty" [popoverTitle]="popTitleEmpty"
      (mouseenter)="p1.open()" #p1="ngbPopover" placement="bottom" (click)="toggleWithGreeting(p1)">
      <img class="pdf-icon save-cart-icon" [src]="'/icons/'+baseSiteId+'/cart.png'" alt="" />
    </a>
  }
  @if (quantityDisplay) {
    <a class="clear-cart" [ngbPopover]="popContentStd" [popoverTitle]="popTitleStd"
      popoverClass="minicart-std-popover" (mouseenter)="p2.open()" #p2="ngbPopover" placement="bottom"
      (click)="toggleWithGreeting(p2)">
      <img class="pdf-icon save-cart-icon" [src]="'/icons/'+baseSiteId+'/cart.png'" alt=""
        [ngbPopover]="popTitleSessionCart" #c1="ngbPopover" triggers="manual" placement="bottom"
        popoverClass="itemincart-success-msg" (click)="c1.close()" container="body" />
      @if (!fluJourneyPage) {
        <p class="cartvalue">{{ quantityDisplay }}</p>
      }
    </a>
  }
  <a class="msg-icon">
    <img class="pdf-icon save-cart-icon mailicon" [src]="'/icons/'+baseSiteId+'/mailicon.svg'" alt=""
      (click)="navigateToNotification()" [ngbPopover]="myNotification" #n1="ngbPopover" triggers="manual"
      placement="bottom" popoverClass="item-notification-msg notificationMsg notificationMsg-mob"
      (mouseenter)="n1.open();closepop()" (mouseleave)="n1.close()" container="body" />
  </a>
  @if (!punchOutKey) {
    <a [ngbPopover]="popTitleSaveSuccess" #s1="ngbPopover" triggers="manual" placement="bottom"
      popoverClass="savedcartsuccess-msg" (click)="s1.close()">
      <img class="pdf-icon save-cart-img" [src]="'/icons/'+baseSiteId+'/saved-orders.png'" alt=""
        (click)="navigateTominiSavedOrder()" [ngbPopover]="myFavText" #h1="ngbPopover" triggers="manual"
        placement="bottom" popoverClass="itemincart-success-msg favTextMsg favorites-mob" (mouseenter)="h1.open()"
        (mouseleave)="h1.close()" container="body" />
    </a>
  }
</section>
<section class="cart-popover">
  <ng-template #popTitleEmpty>
    <div class="minicart-header">
      <span class="mini-triangle"></span>
      <span class="mini-cart-title"></span>
      Your cart is empty
    </div>
  </ng-template>
  <ng-template #popContentEmpty>
    <div class="miniCart-listitem">
      <ul class="text-left">
        <li>
          <a title="Order products" [routerLink]="['/Open-Catalogue/c/1']" (click)="navigateToPdp()">
            Order Products
          </a>
        </li>
        <li>
          <a title="fav" [routerLink]="['/cart/save']" (click)="navigateToSavedOrder()">
            View My Favorites
          </a>
        </li>
      </ul>
    </div>
  </ng-template>
</section>

<section class="cart-popover">
  <ng-template #popTitleStd>
    <div class="minicart-header">
      <span class="mini-triangle"></span>
      <span class="mini-cart-title"></span>
      @if (isSingleLocation && !fluJourneyPage && orderSubTotal != '$--') {
        <span>
          Order subtotal:
        {{ orderSubTotal | currency }}</span>
      }
      @if (isSingleLocation && !fluJourneyPage && orderSubTotal == '$--') {
        <span>
          Order subtotal:
        {{ orderSubTotal }}</span>
      }
      @if (!isSingleLocation && !fluJourneyPage) {
        <span>View cart for price total</span>
      }

      @if (fluJourneyPage) {
        <span>Your cart is empty</span>
      }
    </div>
  </ng-template>
  <ng-template #popContentStd>
    @if (!fluJourneyPage) {
      <section class="cart-prod-list">
        <section class="cart-details-minicart">
          @for (productentry of productEntries; track productentry) {
            <div class="cart-prod-details">
              <ul class="mb-4">
                <section class="unit-numbers minicartInfo">
                  <img [src]="'/icons/'+baseSiteId+'/location.svg'" style="float: left"
                    class="mCS_img_loaded mr-1" />
                  <div class="locationDetails loc_new">
                    <span class="selected-loc minicart-acct-ellipses width-60">
                      {{ productentry.shipToLoc_name }}({{
                      productentry.shipToLoc_id
                      }})
                    </span>
                    <span class="new_unit float-right">
                      {{ productentry.totalUnit }} Units
                    </span>
                  </div>
                </section>
                @for (productentry of productentry.entries; track productentry) {
                  <li>
                    <a class="miniCart-prod-details" (click)="navigatetoProduct(productentry?.product?.code)">
                      @if (productentry?.product?.images != null) {
                        <img class="flu-poster img_loaded"
                          src="{{ productentry.PRIMARY.url }}" alt="" />
                      }
                      @if (productentry?.product?.images == null) {
                        <img
                          [src]="'/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" alt=""
                          class="flu-poster img_loaded" />
                      }
                      <span class="cart-prod-title" [innerHTML]="productentry?.product?.baseProductName"></span>
                    </a>
                    <span class="minicart-prod-doses">{{
                      productentry?.quantity
                    }}</span>
                    <p class="prodDescription">
                      <span class="cart-prod-description cart-prod-title"
                      [innerHTML]="productentry?.product?.baseProductDescription"></span><br />
                      <span class="cart-prod-description cart-prod-title" [innerHTML]="stdFluDesc(productentry)"></span>
                    </p>
                    <p class="miniCart-price">
                      {{productentry?.basePrice?.value < 1 ? "$--" : (productentry?.basePrice?.value | currency) }}
                    </li>
                  }
                </ul>
              </div>
            }
          </section>
          <section class="cart-footer savepopover d-flex flex-column align-items-center" [ngStyle]="{'padding': '10px'}">
            <!-- clearcart:start-->
            <button type="button" class="clearcart clear-cart clear-cart-img-section" [ngbPopover]="popContent"
              [popoverTitle]="popTitle" triggers="manual" #p1="ngbPopover" placement="top"
              popoverClass="savedordermini-popover" (click)="toggle(p1)">
              Clear cart
            </button>
            <ng-template #popTitle><span class="clearcartTilte">
              Clear cart of all products?
            </span>
          </ng-template>
          <ng-template #popContent>
            <div class="clearCartBtnBlock">
              <button type="button" class="btn-secondary" data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
                Cancel
              </button>
              <button class="btn-primary" type="submit" data-di-id="di-id-3064f17d-e97cc628" (click)="clearChildCart()"
                style="padding: 5px 15px !important">
                Clear cart
              </button>
            </div>
          </ng-template>
          <!--clearcart:end-->
          <button type="button" (click)="navigateToCart()" class="btn-primary w-100 mb-2">
            View Cart
          </button>
          @if (!punchOutKey) {
            <button type="button" class="addtofav btn-secondary w-100" [ngbPopover]="popSaveContent"
              [popoverTitle]="popSaveTitle" triggers="manual" #s3="ngbPopover" placement="top"
              popoverClass="savedordermini-popover" (click)="toggle(s3)">
              Add to my favorites
            </button>
          }
          <ng-template #popSaveTitle>
            <span class="minicart-savepopover">
              Name your cart and save it for future orders
            </span>
          </ng-template>
          <ng-template #popSaveContent>
            <div class="paddingAround">
              <input type="text" class="save-order save-order-mini" #name="ngModel" required [(ngModel)]="saveCartName"
                (keypress)="omit_special_char($event)" maxlength="30" />
              @if (name.errors?.required) {
                <span class="common-error required">{{
                  errorMsg
                }}</span>
              }
              <span class="common-error required">{{ errorMsg }}</span>
              <button type="button" class="btn-secondary" (click)="toggle(s3)">
                Cancel
              </button>
              <button class="btn-primary" type="submit" data-di-id="di-id-3064f17d-e97cc628" (click)="saveOrder()"
                [disabled]="!saveCartName">
                Save
              </button>
            </div>
          </ng-template>
        </section>
      </section>
    }
    @if (fluJourneyPage) {
      <section>
        <div class="miniCart-listitem">
          <ul>
            <li>
              <a title="Order products" [routerLink]="['/Open-Catalogue/c/1']" (click)="navigateToPdp()">
                Order Products
              </a>
            </li>
            <li>
              <a title="fav" [routerLink]="['/cart/save']" (click)="navigateToSavedOrder()">
                View My Favorites
              </a>
            </li>
          </ul>
        </div>
      </section>
    }
  </ng-template>
</section>

<section class="cart-popover">
  <ng-template #popTitleFlu>
    <div class="minicart-header">
      <span class="mini-triangle"></span>
      <span class="mini-cart-title"></span>
      {{ "addToCartItems.orderSubtotal" | cxTranslate }}
      {{ fluCartEntries?.subTotal?.value | currency }}
      {{ fluCartEntries?.subTotal?.currencyIso }}
    </div>
  </ng-template>
  <ng-template #popContentFlu>
    <section class="cart-prod-list">
      <section class="unit-numbers">
        <span class="">{{ totalQuantityFlu }}
        {{ "addToCartItems.units" | cxTranslate }}</span>
      </section>
      <section class="cart-details-minicart">
        @for (productentry of productFluEntries; track productentry) {
          <ul class="cart-prod-details">
            <li>
              <a (click)="navigatetoProduct(productentry?.product?.code)">
                <span class="miniCart-prod-details">
                  @if (productentry?.product?.images != null) {
                    <img class="flu-poster img_loaded"
                      src="{{ productentry.PRIMARY.url }}" alt="" />
                  }
                  @if (productentry?.product?.images == null) {
                    <img
                      [src]="'/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" alt=""
                      class="flu-poster img_loaded" />
                  }
                </span>
                <span class="cart-prod-title" [innerHTML]="productentry?.product?.name"></span></a>
                <span class="minicart-prod-doses">{{
                  productentry?.quantity
                }}</span>
                <p class="miniCart-price flu-minicart-price">
                  {{ productentry?.basePrice?.value | currency }}
                  {{ "plp.cad" | cxTranslate }}
                </p>
              </li>
            </ul>
          }
        </section>
        <section class="cart-footer savepopover">
          <a role="presentation" data-di-id="di-id-c676ac20-ae73fdd6">
            <button type="button" (click)="navigateToFlufromCart()" class="btn-primary">
              {{ "addToCartItems.viewcart" | cxTranslate }}
            </button>
          </a>
        </section>
      </section>
    </ng-template>
  </section>

  <section class="added-success-container">
    <ng-template #popTitleSuccess>
      <div class="cart-value-added">
        <img [src]="'/icons/'+baseSiteId+'/confirmation-positive-green.png'" class="positive-green-icon"
          alt="success" />
        <span class="confirmation-itemsadded">{{ itemAddedQuantity }}
        {{ "addToCartItems.addEntrySuccess" | cxTranslate }}</span>
      </div>
    </ng-template>
  </section>
  <ng-template #popTitleSaveSuccess>
    <div class="cart-value-added">
      <img [src]="'/icons/'+baseSiteId+'/confirmation-positive-green.png'" class="positive-green-icon"
        alt="success" />
      <span class="confirmation-itemsadded">
        Your cart has been saved !
      </span>
    </div>
  </ng-template>
  <ng-template #myFavText>
    <div class="cart-value-added myFavDiv">
      <span class="confirmation-itemsadded textSpan">My Favorites</span>
    </div>
  </ng-template>
  <ng-template #myNotification>
    <div class="noti-value-added myNotiDiv">
      <span class="notification-msg">Notification message center</span>
    </div>
  </ng-template>

  <!--Modal:start-->

  <div id="cartNotificationPopup" class="modal in modalbg popup-comp items-in-cart" data-backdrop="true" role="dialog"
    style="display: none" (click)="$event.stopPropagation(); closePopup()">
    <div class="modal-dialog pop1">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title-top20">Items in your cart</h4>
        </div>
        <div class="modal-body">
          <p class="cart-text">
            <b>{{ quantityDisplay }}</b> item(s) in your cart from your last
            session
          </p>
        </div>
        <div class="modal-footer">
          <div class="miniCart-foot d-flex flex-column">
            <button type="button" class="btn-primary viewCartBtn" (click)="naviToCartModal()">
              View Cart
            </button>
            <button type="button" class="btn-secondary continueShoppingBtn" (click)="naviToPdpModal()"
              style="margin-right: 0 !important">
              Continue Shopping
            </button>
            <a href="javascript:void(0)" class="clearCartmod" title="Clear Cart" (click)="clearCartModal()">Clear Cart</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Modal:end-->
